module.exports = __webpack_public_path__ + "static/media/2D.fd3b1e79.svg";